// 请求工具函数，用于处理API请求，自动带上token

export const request = async (url, options = {}) => {
  // 获取存储的token
  const token = localStorage.getItem('token');
  
  // 合并默认选项和传入选项
  const config = {
    method: 'POST', // 默认使用POST方法
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    ...options
  };
  
  // 如果有token，添加Authorization header
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  try {
    const response = await fetch(url, config);
    
    // 处理403状态码，跳转到登录页面
    if (response.status === 403) {
      // 清除存储的token
      localStorage.removeItem('token');
      // 跳转到登录页面
      window.location.href = '/manage/login';
      return;
    }
    
    // 根据responseType处理响应
    if (config.responseType === 'blob') {
      const data = await response.blob();
      return data;
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error('请求错误:', error);
    throw error;
  }
};
